import React from 'react'
import { Input } from 'antd'
import './index.scss';

function FlyInput(props) {
    return  <Input className="fly-input" {...props} />
}

export default FlyInput
